import script from "./PoolSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoolSummary.vue?vue&type=script&setup=true&lang=ts"

import "./PoolSummary.vue?vue&type=style&index=0&id=36e9247b&lang=css"

const __exports__ = script;

export default __exports__